import { defineComponent, h, Transition } from "vue"
import { RouterView } from "vue-router"
import navigate from "../routes/navigate"

export default defineComponent({
  methods: { close: () => navigate() },
  mounted() {},
  props: [] as const,
  render() {
    return (
      <div class="router-view">
        {h(RouterView, null, {
          default: ({ Component, route }: { Component: any; route: any }) => {
            return Component
              ? h(Transition, { name: "router" }, () =>
                  h(Component, { key: route.name, ...route.props })
                )
              : null
          },
        })}
        <div
          class="router-backdrop bg-glass-dark overflow-hidden"
          onClick={this.close}
          onTouchmove={(e: Event) => {
            e.stopPropagation()
            e.preventDefault()
          }}
          onWheel={(e: Event) => {
            e.stopPropagation()
            e.preventDefault()
          }}
        ></div>
      </div>
    )
  },
})
